import React from "react";

import IntroImage from "./IntroImage";
import IntroText from "./IntroText";

export default function Intro() {
  return (
    <section
      className="relative h-screen bg-fixed bg-center bg-gray-700 bg-cover w-full"
      // style={{
      //   backgroundImage: `url(${imageUrl})`,
      //   backgroundSize: "cover", // Optional: to cover the entire div
      //   backgroundPosition: "center", // Optional: to center the image
      // }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-45 flex flex-col md:flex-row justify-center items-center p-4 pt-[4vh] md:p-[10%] m-2">
        <IntroImage />
        <IntroText />
      </div>
    </section>
  );
}
